import { createGlobalStyle } from 'styled-components';
import { theme } from 'assets/styles/theme';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    max-height: 1000000px;
  }

  html {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    width: 100%;
    overflow-x: clip;
  }
  *, *:before, *:after {
    box-sizing: inherit;
    -moz-box-sizing: inherit;
    -webkit-box-sizing: inherit;
  }
  body {
    background: ${theme.bodyBg};
    color: ${theme.text};
    font: ${theme.baseFontSize}/${theme.baseLineHeight} ${theme.fontFamily};
    margin: 0;
    min-width: 0;
    width: 100%;
    overflow-x: clip;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }

  .app-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    min-width: 0;
    overflow-x: clip;
  }

  #root {
    width: 100%;
    min-width: 0;
  }

  #root,
  .app-container {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .app-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  img {
    border-style: none;
    max-width: 100%;
    height: auto;
    display: block;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: clamp(1.25rem, 4vw, 2.25rem);
    font-weight: 600;
    line-height: 1.23;
    margin: 0 0 20px;
    text-transform: capitalize;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  h2 { font-size: clamp(1.25rem, 4vw, 2.25rem); }
  h3 { font-size: clamp(1.125rem, 3.5vw, 2rem); }
  h4 { font-size: clamp(1rem, 3vw, 1.75rem); }
  h5 { font-size: clamp(0.95rem, 2.5vw, 1.5625rem); }
  h6 { font-size: clamp(0.9rem, 2vw, 1.25rem); }

  p {
    margin: 0 0 20px;
  }
  input,
  button {
    outline: none;
  }
  article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section, main { display: block; }
  * { max-height: 1000000px; }
  ul, ol {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  ul>li { list-style-type: none; }
  a {
    text-decoration: none;
  }
  button {
    background: ${theme.primary};
    border-radius: 4px;
    height: 48px;
    text-align: center;
    color: ${theme.bodyBg};
    padding: 0 18px;
    border: 1px solid transparent;
    font-size: ${theme.lgFontSize};
    cursor: pointer;
    transition: linear 0.3s;
    white-space: normal;

    @media (min-width: 576px) {
      white-space: nowrap;
    }

    path {
      stroke: ${theme.bodyBg};
    }

    svg {
      vertical-align: middle;
      margin-left: 10px;
    }

    &:hover {
      border-color: ${theme.primary};
      color: ${theme.primary};
      background: ${theme.bodyBg};

      path {
        stroke: ${theme.primary};
      }
    }

    &.group {
      background: none;
      color: ${theme.secondary};
      border-color: ${theme.secondary};

      &:hover {
        background: ${theme.secondary};
        color: ${theme.bodyBg};
      }

      &.disabled,
      &:disabled {
        background: ${theme.lightGray};
        border-color: ${theme.lightGray};
        color: ${theme.bodyBg};
        pointer-events: none;

        img {
          &.group {
            display: none;
          }
          &.group-white {
            display: inline-block;
            vertical-align: bottom;
          }
        }
      }
    }

    &.outline {
      border-color: ${theme.secondary};
      color: ${theme.secondary};
      background: ${theme.bodyBg};

      &:hover {
        background: ${theme.secondary};
        color: ${theme.bodyBg};
      }
    }

    &.link {
      border-color: ${theme.bodyBg};
      color: ${theme.primary};
      background: ${theme.bodyBg};
      height: auto;

      path {
        stroke: ${theme.primary};
      }

      &:hover {
        text-decoration: underline;
      }
    }

    &.disabled {
      cursor: not-allowed;
      color: ${theme.bodyBg};
      border-color: ${theme.lightGray};
      background: ${theme.lightGray};
      pointer-events: none;

      &:hover {
        border-color: ${theme.lightGray};
        color: ${theme.bodyBg};
        background: ${theme.lightGray};
      }
    }
  }

  .form-control {
    width: 100%;
    border: 2px solid ${theme.gray};
    height: 48px;
    font-size: 16px;
    line-height: 28px;
    color: ${theme.text};
    padding: 8px 16px;
    border-radius: 4px;
    outline: none;

    &:focus {
      border-color: ${theme.primary};
      outline: 0;
      box-shadow: 0 0 0 3px rgba(86, 183, 247, .25);
    }
  }

  select.form-control {
    -webkit-appearance: none;
    appearance: none;
    paddingRight: 30px;
  }

  ::-webkit-input-placeholder { ${theme.textSecondary}; }
  :-moz-placeholder { color: ${theme.textSecondary}; }
  ::-moz-placeholder {
    color: ${theme.textSecondary};
    opacity: 1;
  }
  :-ms-input-placeholder { color: ${theme.textSecondary}; }
  .no-data {
    padding: 40px 10px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
  }
  [hidden],
  .hidden {
    display: none !important;
  }
  .page-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      color: ${theme.primary};
    }
  }
`;

export default GlobalStyle;
